<template>
  <div class="species-input-form">
    <div class="row name">
      <text-input-form
        data-test="name"
        :maxlength="15"
        :placeholder="'15文字まで'"
        :required-flg="true"
        :styles="{ width: '350px' }"
        v-model="species.name"
        >種別名</text-input-form
      >
    </div>
    <div v-if="enAvailable" class="row name-english">
      <text-input-form
        data-test="name-english"
        :maxlength="30"
        :placeholder="'30文字まで'"
        :required-flg="true"
        :styles="{ width: '350px' }"
        v-model="species.nameEnglish"
        >種別名（英語）</text-input-form
      >
    </div>
    <div v-if="measurementAvailable" class="row">
      <select-box-form
        data-test="master-laboratory-species-code"
        :is-value-string="true"
        :select-data="laboratorySpeciesOptions"
        :styles="{ width: '160px' }"
        :value-key="'code'"
        v-model="species.masterLaboratorySpeciesCode"
        >検査動物種
      </select-box-form>
    </div>
  </div>
</template>

<script>
import SelectBoxForm from '@/components/parts/molecules/SelectBoxForm'
import TextInputForm from '@/components/parts/molecules/TextInputForm'

export default {
  name: 'SpeciesInputForm',

  components: {
    SelectBoxForm,
    TextInputForm
  },

  props: {
    species: { type: Object }
  },

  data() {
    const clinic = this.$store.getters['clinic/getData']
    const reservationSetting = this.$store.getters['reservationSetting/getData']
    return {
      enAvailable: reservationSetting.englishOptionFlg === 1,
      measurementAvailable: clinic.measurementFlg === 1
    }
  },

  computed: {
    laboratorySpeciesOptions() {
      const masterLaboratorySpecies = this.$store.getters[
        'master/getMasterLaboratorySpecies'
      ].map(v => ({ code: v.code, name: v.name }))
      return [{ code: '', name: '' }].concat(masterLaboratorySpecies)
    }
  }
}
</script>

<style lang="scss" scoped>
.species-input-form {
  > .row ~ .row {
    margin-top: 25px;
  }
}
</style>
